var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3554 3.53299C14.3655 3.68804 14.3655 3.84312 14.3655 3.99816C14.3655 8.72727 11.066 14.1763 5.03555 14.1763C3.17767 14.1763 1.45179 13.5893 0 12.5704C0.26397 12.6036 0.517752 12.6147 0.791878 12.6147C2.32485 12.6147 3.73605 12.0499 4.86296 11.0863C3.42133 11.0531 2.2132 10.0231 1.79694 8.60547C2.00001 8.63867 2.20304 8.66083 2.41626 8.66083C2.71067 8.66083 3.00511 8.61651 3.2792 8.53902C1.77666 8.20674 0.649721 6.76697 0.649721 5.02816V4.98387C1.08625 5.24968 1.59391 5.41581 2.13195 5.43793C1.24869 4.79555 0.670034 3.69912 0.670034 2.45868C0.670034 1.79418 0.832441 1.18504 1.11672 0.653423C2.73095 2.82417 5.15736 4.24178 7.87816 4.39686C7.82741 4.13105 7.79694 3.8542 7.79694 3.57731C7.79694 1.60589 9.25888 0 11.0761 0C12.0203 0 12.8731 0.431934 13.4721 1.12967C14.2132 0.974629 14.9238 0.675582 15.5533 0.265808C15.3096 1.09647 14.7919 1.79421 14.1117 2.23719C14.7716 2.1597 15.4112 1.9603 16 1.68345C15.5534 2.39224 14.995 3.0235 14.3554 3.53299Z",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1db6416511113c6f1fc564b79b3937a9.svg";
export { ForwardRef as ReactComponent };